import {
    COMPANY_CHANGE, COMPANY_CHANGE_COUNT, COMPANY_ERROR, COMPANY_REQUEST,
    COMPANY_SUCCESS,COMPANY_FILTERS_RESET,COMPANY_OFFER_CHANGE,
    COMPANY_RESET, COMPANY_RESET_DATA,COMPANY_FILTERS_CHANGE,
    COMPANY_REMOVE_BINDINGS, COMPANY_UPLOAD_BINDINGS_REQUEST,COMPANY_UPLOAD_BINDINGS_RESULT 
} from "../actions/companyActions";

import {CookiesSettings} from '../helpers/cookiesHelper'

let cookiesSetting = new CookiesSettings("company")

let count = cookiesSetting.get("count");
if(!count){
    count = 15
    cookiesSetting.set("count",count)
}
const initialState = {
    id:null,
    companyBindToId:null,
    data:[],
    page:1,
    count:count,
    total:0,
    fetching:false,
    set:false,
    needRefresh: false,
    offerId:"",
    bindingFile:null,
    uploadResult:[],
    filters:{
        bindingType:"0",
        onlyAutoBinded:false,
        file:null        
    }
}

export default function company(state=initialState, action) {
    let {data} = state;
    switch (action.type){
        case COMPANY_REQUEST:
            return{
                ...state,
                fetching:true,
                needRefresh:false
            }
        case COMPANY_ERROR:
            return{
                ...state,
                fetching:false,
                data:initialState.data
            }
        case COMPANY_SUCCESS:
            return{
                ...state,
                fetching:false,
                needRefresh: false,
                set:true,
                data:action.payload.rows,
                total:action.payload.totalNumberOfResults

            }
        case COMPANY_CHANGE_COUNT:
            cookiesSetting.set("count",action.payload)
            return{
                ...state,
                needRefresh:true,
                page:1,
                count:action.payload
            }
        case COMPANY_CHANGE:
            return{
                ...state,
                [action.payload.field]:action.payload.value
            }
        case COMPANY_FILTERS_RESET:
            return{
                ...state,
                needRefresh:true,
                page:initialState.page,
                filters:initialState.filters,
                offerId:initialState.offerId
            }
        case COMPANY_FILTERS_CHANGE:
            return{
                ...state,
                needRefresh:true,
                page:initialState.page,
                filters:action.payload
            }
        case COMPANY_OFFER_CHANGE:
            let {offerBindToId} = action.payload;

            for(let i = 0 ; i< data.length; i++){
                if(data[i].offerBindToId === offerBindToId){
                    data[i] = {
                        ...data[i],
                        ...action.payload
                    }
                }
            }

            return{
                ...state,
               data:data
            }
        case COMPANY_RESET:
            let count = state.count;
            return {
                ...initialState,
                count
            }
        case COMPANY_RESET_DATA:
            return {
                ...state,
                data:initialState.data,
                total:initialState.total,
                page:initialState.page,
                uploadResult:initialState.uploadResult,
            }
        case COMPANY_REMOVE_BINDINGS:
            return{
                ...state,
                needRefresh:true
            }
        case COMPANY_UPLOAD_BINDINGS_REQUEST:
            return{
                ...state,
                fetching:true,
                needRefresh:false
            }
        case COMPANY_UPLOAD_BINDINGS_RESULT:
            return{
                ...state,
                fetching:false,
                needRefresh: false,
                set:true,
                uploadResult:action.payload,
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/company.js